export default __webpack_public_path__ + "static/media/bs-secondary-pick-up.6218d0bc.svg";